import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { cache } from './cache';
import { authLink, httpLink, restLink, errorLink } from './links';

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([authLink, errorLink, restLink, httpLink]),
});
